import * as AT from '../constants/actionTypes'

/**
 * Panel consent reducer
 * @param {*} state 
 * @param {*} action 
 */
function panelConsent(state = { cycleName: undefined, isLoading: false, isSaving: false, hasConsented: false }, action) {
	switch (action.type) {
		case AT.PANEL_CONSENT_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				cycleName: undefined,
				error: undefined
			})
		case AT.PANEL_CONSENT_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				cycleName: undefined,
				error: action.payload.error
			})
		case AT.PANEL_CONSENT_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				cycleName: action.payload.cycleName,
				error: undefined
			})
		case AT.PANEL_CONSENT_SAVING_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.PANEL_CONSENT_SAVING_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.PANEL_CONSENT_SAVING_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				hasConsented: true,
				error: undefined
			})
		case AT.PANEL_CONSENT_CHECK_STARTED:
			return Object.assign({}, state, {
				isCheckingConsent: true,
				error: undefined
			})
		case AT.PANEL_CONSENT_CHECK_FAILED:
			return Object.assign({}, state, {
				isCheckingConsent: false,
				error: action.payload.error
			})
		case AT.PANEL_CONSENT_CHECK_FINISHED:
			return Object.assign({}, state, {
				isCheckingConsent: false,
				hasConsented: action.payload.hasConsented,
				consentTimestamp: action.payload.timestamp,
				error: undefined
			})
		default:
			return state;
	}
}

export default panelConsent;
